var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { memo, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Tab, Tabs } from "react-bootstrap";
// components
import { PurchaseComponent, TopupComponent, RedeemComponent, TransferIn, CommonClientSearch, ClientDetails, } from "../../components";
import Redirection from "../../components/TableComponent/Redirection";
import DraftAlready from "../../components/TableComponent/DraftAlready";
import SuccessPage from "../../components/TableComponent/SuccessPage";
import { ToastModal } from "../../components/common";
import Loader from "@frameworks/shared-library/components/Loader";
// redux
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
// types
import { TransactionTypeCodeEnum, TransactionTypeEnum, } from "@domains/features/Markets/AIF-PMS/entities/GlobalEntity";
import LeadCreation from "../../pages/LeadCreation";
import actions from "@mainDi/features/AIF-PMS/actions";
import ConfirmRmSelection from "../../pages/LeadCreation/components/ConfirmRmSelection";
import useTransactionType from "../../hooks/useTransactionType";
function PurchaseBody(_a) {
    //
    var _this = this;
    var _b, _c, _d, _e;
    var onSelectClient = _a.onSelectClient, loading = _a.loading, subCategoryId = _a.subCategoryId, leadId = _a.leadId, setLeadId = _a.setLeadId, rmSelection = _a.rmSelection, leadNotExists = _a.leadNotExists, setLeadNotExits = _a.setLeadNotExits, errorVisible = _a.errorVisible, errorMessage = _a.errorMessage, setIsCxoButtonEnabled = _a.setIsCxoButtonEnabled;
    var searchParams = new URLSearchParams(location.search);
    var _f = useSelector(function (state) { return state.markets.AifPms; }), clientDetails = _f.clientDetails, orderData = _f.orderData, watchListData = _f.watchListData, draftOrderDetails = _f.draftOrderDetails;
    var leadData = useSelector(function (state) { return state.markets.leadservice; }).leadData;
    var _g = useSelector(function (state) { return state.markets.global; }), trxTypeList = _g.trxTypeList, activeTypeList = _g.activeTypeList;
    var _h = __read(useState([]), 2), localTrxTypeList = _h[0], setLocalTrxTypeList = _h[1];
    var paymentSuccess = useSelector(function (state) { return state.markets.payment; }).paymentSuccess;
    var profileData = useSelector(function (state) {
        return state.Profile.ProfileDetails.reducersData.data.profileDetails;
    });
    var cActions = actions();
    var saveDraftOrders = useSelector(function (state) { return state.markets.draft; }).saveDraftOrders;
    var orders = useSelector(function (state) { return state.markets.purchase; }).orders;
    var isRedeemOrTransferIn = useTransactionType(activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code);
    // useEffect(() => {
    //   if (
    //     searchParams.get("leadid") !== "" &&
    //     searchParams.get("leadid") !== null &&
    //     searchParams.get("leadid") !== undefined &&
    //     !draftOrderDetails?.data
    //   ) {
    //     const leadId = searchParams.get("leadid");
    //     const notExits =
    //       leadData?.data == null
    //         ? true
    //         : leadData?.data?.some((element) => element?.leadId !== leadId);
    //     setLeadNotExits(
    //       leadData?.data?.some((element) => element?.leadId == leadId)
    //         ? false
    //         : notExits
    //     );
    //   }
    // }, [leadData]);
    var handleTabSelect = function (eventKey) {
        var _a, _b;
        if (!searchParams.get("orderId")) {
            var filter = (_b = (_a = trxTypeList === null || trxTypeList === void 0 ? void 0 : trxTypeList.data) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item.trx_type_code == Number(eventKey); })[0]) !== null && _b !== void 0 ? _b : {
                trx_type: TransactionTypeEnum.Purchase,
                trx_type_code: TransactionTypeCodeEnum.Purchase,
            };
            aifPmsDi.global.activeTrxTypeList(filter);
            aifPmsDi.payment.resetValue();
            cActions.leadservice.searchLead(null);
            setIsCxoButtonEnabled(false);
            // if (
            //   searchParams.get("leadid") !== "" &&
            //   searchParams.get("leadid") !== null &&
            //   searchParams.get("leadid") !== undefined
            // ) {
            //   cActions.global.selectLeadId(searchParams.get("leadid"));
            //   setLeadId(false);
            // } else {
            //   cActions.global.selectLeadId(null);
            //   setLeadId(true);
            // }
            cActions.draft.draftOrderDetails(null);
            aifPmsDi.payment.updatePurchaseSuccess(false);
            cActions.leadservice.selectLoginSearchData(null);
            if ((activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code) !== Number(eventKey)) {
                if (!searchParams.get("ucc")) {
                    aifPmsDi.aifPms.updateClientDetails(null);
                }
                aifPmsDi.purchase.updateOrders(null);
                aifPmsDi.aifPms.updateTransactionId(0);
            }
            if (saveDraftOrders !== null) {
                aifPmsDi.draft.updateDraftOrders(null);
            }
        }
    };
    var getComponentForTransactionType = useMemo(function () {
        var _a;
        if (clientDetails &&
            paymentSuccess === false &&
            (((_a = orders === null || orders === void 0 ? void 0 : orders.data) === null || _a === void 0 ? void 0 : _a.status) === "FAILURE" || !orders)) {
            var showLeadCreation_1 = !(draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) && leadId && !rmSelection;
            var showDefaultComponent_1 = clientDetails.ispansearch == null && !rmSelection;
            var hasDraft_1 = !!(draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data);
            var commonProps = {
                setLeadId: setLeadId,
                setIsCxoButtonEnabled: setIsCxoButtonEnabled,
            };
            var getMainComponent = function (Component, LeadComp) {
                if (showLeadCreation_1)
                    return React.createElement(LeadCreation, null);
                if (showDefaultComponent_1 || hasDraft_1)
                    return Component;
                if (leadId)
                    return rmSelection ? React.createElement(ConfirmRmSelection, null) : LeadComp;
                return Component;
            };
            switch (activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code) {
                case TransactionTypeCodeEnum.Purchase:
                    return getMainComponent(React.createElement(PurchaseComponent, __assign({ subCategoryId: subCategoryId }, commonProps)), React.createElement(LeadCreation, null));
                case TransactionTypeCodeEnum.TopUp:
                    return getMainComponent(React.createElement(TopupComponent, __assign({}, commonProps)), React.createElement(LeadCreation, null));
                case TransactionTypeCodeEnum.Redeem:
                    return React.createElement(RedeemComponent, null);
                case TransactionTypeCodeEnum.TransferIn:
                    return React.createElement(TransferIn, null);
                default:
                    return null;
            }
        }
        return null;
    }, [
        clientDetails,
        paymentSuccess,
        orders,
        activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code,
        leadId,
        rmSelection,
        draftOrderDetails,
        subCategoryId,
        setLeadId,
        setIsCxoButtonEnabled,
    ]);
    useEffect(function () {
        var _a;
        if (searchParams.get("ucc") && searchParams.get("categoryCode")) {
            var list = (_a = trxTypeList === null || trxTypeList === void 0 ? void 0 : trxTypeList.data) === null || _a === void 0 ? void 0 : _a.filter(function (item) {
                return ![
                    TransactionTypeCodeEnum.Redeem,
                    TransactionTypeCodeEnum.TransferIn,
                ].includes(item === null || item === void 0 ? void 0 : item.trx_type_code);
            });
            aifPmsDi.aifPms.updateTransactionId(Number(searchParams.get("orderId")));
            setLocalTrxTypeList(list);
        }
        else {
            setLocalTrxTypeList(trxTypeList === null || trxTypeList === void 0 ? void 0 : trxTypeList.data);
        }
    }, [trxTypeList === null || trxTypeList === void 0 ? void 0 : trxTypeList.data]);
    function checkFourthChar(input) {
        var _a;
        if ((input === null || input === void 0 ? void 0 : input.length) >= 4 && ((_a = input === null || input === void 0 ? void 0 : input[3]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === "P") {
            return 55;
        }
        return 56;
    }
    // useEffect(() => {
    //   if (
    //     !isRedeemOrTransferIn &&
    //     clientDetails &&
    //     (clientDetails?.ispansearch === "false" ||
    //       clientDetails?.ispansearch === null)
    //   ) {
    //     aifPmsDi.leadservice.leadsSearch({
    //       searchBy: "CRITERIA_ALL_LEAD",
    //       assignedTo: profileData?.empcodetxt ? profileData?.empcodetxt : "",
    //       mobile: clientDetails?.mobileNo ? clientDetails?.mobileNo : "",
    //       emailId: clientDetails?.email ? clientDetails?.email : "",
    //       productId: Number(EProductIds.MANAGED_PORTFOLIO),
    //       categoryId: subCategoryId,
    //       subCategoryId: 0,
    //       leadSource: "AIFPMS",
    //       displayNameId: watchListData?.schemeId,
    //       pan: clientDetails?.pan,
    //       EntityTypeId: checkFourthChar(clientDetails?.pan),
    //     });
    //   }
    // }, [clientDetails?.pan]);
    useEffect(function () {
        if (!isRedeemOrTransferIn && draftOrderDetails) {
            var getUccData = function () { return __awaiter(_this, void 0, void 0, function () {
                var response, client;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, aifPmsDi.global.uccCodeClientSearch({
                                uccCode: (_a = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _a === void 0 ? void 0 : _a.ucccode,
                            })];
                        case 1:
                            response = _b.sent();
                            client = response === null || response === void 0 ? void 0 : response.data;
                            return [2 /*return*/];
                    }
                });
            }); };
            if (!searchParams.get("orderId")) {
                getUccData();
            }
        }
    }, [(_b = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _b === void 0 ? void 0 : _b.lead_id]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "aif-pms-sidebar-body" },
            React.createElement("div", { className: "custom-tabs-container ".concat(searchParams.get("ucc") &&
                    searchParams.get("categoryCode") &&
                    "align-items-start") },
                React.createElement(Tabs, { activeKey: activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code, onSelect: handleTabSelect, id: "custom-tabs", className: "custom-tabs DMsanL_12_300" }, localTrxTypeList === null || localTrxTypeList === void 0 ? void 0 : localTrxTypeList.map(function (item) { return (React.createElement(Tab, { eventKey: item.trx_type_code, title: item.trx_type, key: item.trx_type_code })); })),
                loading && React.createElement(Loader, null),
                ((_c = saveDraftOrders === null || saveDraftOrders === void 0 ? void 0 : saveDraftOrders.data) === null || _c === void 0 ? void 0 : _c.status) == "FAILUREDRAFT" ? (React.createElement("div", { className: "rounded auto-height-without-footer position-relative width-375" },
                    React.createElement(ClientDetails, { footer: false, className: "px-3 py-4-custom box-shadow-light" }),
                    React.createElement(DraftAlready, null))) : (React.createElement("div", { className: "rounded ".concat(!paymentSuccess
                        ? "auto-height"
                        : (orderData === null || orderData === void 0 ? void 0 : orderData.issuer_redirection_url)
                            ? "auto-height-without-footer"
                            : "auto-height", " width-375 position-relative ") },
                    clientDetails == null && (React.createElement(React.Fragment, null,
                        React.createElement(CommonClientSearch, { subCategoryId: subCategoryId, onSelectClient: function (item) {
                                if (onSelectClient) {
                                    onSelectClient(item);
                                    setLeadId(profileData === null || profileData === void 0 ? void 0 : profileData.isCxo);
                                }
                            } }))),
                    loading == false &&
                        paymentSuccess == false &&
                        getComponentForTransactionType,
                    paymentSuccess &&
                        clientDetails !== null &&
                        ![
                            TransactionTypeCodeEnum.Redeem,
                            TransactionTypeCodeEnum.TransferIn,
                        ].includes(activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code) &&
                        ((orderData === null || orderData === void 0 ? void 0 : orderData.issuer_redirection_url) ? (React.createElement(Redirection, null)) : (React.createElement(SuccessPage, null))),
                    paymentSuccess &&
                        clientDetails !== null &&
                        ((activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code) ==
                            TransactionTypeCodeEnum.Redeem ||
                            (activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code) ==
                                TransactionTypeCodeEnum.TransferIn) && React.createElement(SuccessPage, null)))),
            React.createElement(ToastModal, { visible: (orders === null || orders === void 0 ? void 0 : orders.message) == "Invalid Data.", setVisible: function () {
                    aifPmsDi.purchase.updateOrders(__assign(__assign({}, orders), { message: "" }));
                }, message: (_e = (_d = orders === null || orders === void 0 ? void 0 : orders.data) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : "" }),
            React.createElement(ToastModal, { visible: errorVisible, setVisible: function () { }, message: errorMessage, isError: true }))));
}
export default memo(PurchaseBody);
